import HeadData from 'components/Common/HeadData'
import { OFFER_TYPE_LAST_MINUTE } from 'constants/offer'
import { scheduleIsCurrent } from 'lib/offer/scheduleStatusUtils'
import React from 'react'
import OfferGoogleProductDataScript from './OfferGoogleProductDataScript'
import HotelStructuredData from './HotelStructuredData'
import { LUXURY_PLUS } from 'luxPlus/constants/base'
import { getImageUrl } from 'lib/image/imageUtils'
import { getHeadDescription, getHeadTitle, isMetadataExperimentOn } from 'components/OfferPage/utils'
import { RouteComponentProps, withRouter } from 'react-router'

interface Props extends RouteComponentProps {
  offer: App.HotelOffer | App.VillaOffer | App.TourOffer
  /**
   * There are exclusive LuxPlus+ offers. They should
   * appear as hidden offers to non-members
   */
  isLuxPlusHiddenOffer?: boolean
}

function OfferPageHeadData(props: Props) {
  const { offer, isLuxPlusHiddenOffer, match } = props
  const { url } = match

  const availableForPurchase = scheduleIsCurrent(offer.onlinePurchaseSchedule)
  const isMetadataExperiment = isMetadataExperimentOn(url)

  let title = ''
  let description = ''
  let imageUrl = ''

  if (isLuxPlusHiddenOffer) {
    title = `${LUXURY_PLUS.PROGRAM_NAME} Member Exclusive`
    description = `Unlock hidden hotel offers available exclusively for ${LUXURY_PLUS.PROGRAM_NAME} members. These escapes aren't available anywhere else`
    imageUrl = offer.images[0].id ? getImageUrl(offer.images[0].id, { width: 65, format: 'jpeg', quality: 'low' }) : ''
  } else {
    title = getHeadTitle(offer, isMetadataExperiment)
    description = getHeadDescription(offer, isMetadataExperiment)
    imageUrl = offer.images[0].id ? getImageUrl(offer.images[0].id, { width: 650, format: 'jpeg' }) : ''
  }

  return (
    <>
      <HeadData
        title={title}
        description={description}
        noIndex={offer.noIndex || !availableForPurchase}
        imageId={offer.images[0].id}
        imageUrl={imageUrl}
      />
      {offer.property && <HotelStructuredData offer={offer} />}
      {offer.type !== OFFER_TYPE_LAST_MINUTE && (
        <OfferGoogleProductDataScript
          availableForPurchase={availableForPurchase}
          offer={offer}
        />
      )}
    </>
  )
}

export default withRouter(OfferPageHeadData)
